import api from './../../util/api.js'
// initial state
const state = {
  headChange: false,
  goPersonalCenter: false,
  registerChange: false,
  signChange: false,
  removeAct: false,
  member: null,
  collectionTotalCount: 0,
  favoriteTotalCount: 0
};
// getters
const getters = {};

// actions
const actions = {
  getFavoriteTotalCount({ commit }) {
    // 获取收藏数据
    const favoriteParams = {};
    favoriteParams.no = 1;
    favoriteParams.pageSize = 8;
    favoriteParams.status = 1;
    api.listMemberFavoriteByPage(favoriteParams).then(response => {
      if (response.data.code === 'success') {
        commit('setFavoriteTotalCount', response.data.data.totalCount);
      } else {
        console.log(response.data.message, 'error');
      }
    }).catch(error => {
      console.log(error);
    });
  },
  getCollectionTotalCount({ commit }) {
    // 获取足迹数据
    const collectionParams = {};
    collectionParams.dataNum = 3;
    collectionParams.status = 1;
    api.listMemberHistory(collectionParams).then(response => {
      if (response.data.code === 'success') {
        commit('setCollectionTotalCount', response.data.data.totalCount);
      } else {
        console.log(response.data.message, 'error');
      }
    }).catch(error => {
      console.log(error);
    });
  },
  setFavoriteTotalCount(context, data) {
    context.commit('setFavoriteTotalCount',data);
  },
  setCollectionTotalCount(context, data) {
    context.commit('setCollectionTotalCount',data);
  },
  fetchUserInfo({ commit }) {
    // 获取用户信息
    let apiKey = localStorage.getItem('apiKey');
    const apiKeyDate = Number(window.localStorage.getItem('apiKeyDate'));
    const currentDate = new Date().getTime();
    const utc = currentDate - apiKeyDate;
    const day = utc / (24 * 60 * 60 * 1000);
    if (apiKey) {
      if (day < 1) {
        api.getMemberInfoTx().then(response => {
          if(response.data.code === 'success') {
            window.Countly.q.push(['add_event', {
              key: '用户登录',
              count: 1
            }]);
            window.Countly.q.push(['user_details',{
              // 必填
              "name": response.data.data.nickname,
              // 必填
              "username": response.data.data.username
            }]);
            commit('setMember', response.data.data);
          } else if (response.data.message === '18001') {
            window.localStorage.removeItem('apiKey');
            window.localStorage.removeItem('apiKeyDate');
          } else {
            console.log(response.data.message, 'error');
          }
        }).catch(() => {
          console.log("网络异常")
        });
        // 获取收藏数据
        const favoriteParams = {};
        favoriteParams.no = 1;
        favoriteParams.pageSize = 8;
        favoriteParams.status = 1;
        favoriteParams.type = null;
        // type( 1：整车，2：精品配件，3：活动产品)
        favoriteParams.searchName = null;
        api.listMemberFavoriteByPage(favoriteParams).then(response => {
          if (response.data.code === 'success') {
            commit('setFavoriteTotalCount', response.data.data.totalCount);
          } else if (response.data.message === '18001') {
            window.localStorage.removeItem('apiKey');
            window.localStorage.removeItem('apiKeyDate');
          } else {
            console.log(response.data.message, 'error');
          }
        }).catch(error => {
          console.log(error);
        });
        // 获取足迹数据
        const collectionParams = {};
        collectionParams.dataNum = 3;
        collectionParams.status = 1;
        api.listMemberHistory(collectionParams).then(response => {
          if (response.data.code === 'success') {
            commit('setCollectionTotalCount', response.data.data.totalCount);
          } else if (response.data.message === '18001') {
            window.localStorage.removeItem('apiKey');
            window.localStorage.removeItem('apiKeyDate');
          } else {
            console.log(response.data.message, 'error');
          }
        }).catch(error => {
          console.log(error);
        });
      } else {
        window.localStorage.removeItem('apiKey');
        window.localStorage.removeItem('apiKeyDate');
      }
    }
  },
  headChange(context) {
    //这里的context和我们使用的$store拥有相同的对象和方法
    context.commit('headChange');
    //你还可以在这里触发其他的mutations方法
  },
  goPersonalCenter(context) {
    //这里的context和我们使用的$store拥有相同的对象和方法
    context.commit('goPersonalCenter');
    //你还可以在这里触发其他的mutations方法
  },
  registerChange(context) {
    //这里的context和我们使用的$store拥有相同的对象和方法
    context.commit('registerChange');
    //你还可以在这里触发其他的mutations方法
  },
  signChange(context) {
    //这里的context和我们使用的$store拥有相同的对象和方法
    context.commit('signChange');
    //你还可以在这里触发其他的mutations方法
  },
  removeAct(context) {
    //这里的context和我们使用的$store拥有相同的对象和方法
    context.commit('removeAct');
    //你还可以在这里触发其他的mutations方法
  },
  setMember(context,member) {
    context.commit('setMember',member);
  },
  removeMember(context) {
    context.commit('removeMember');
  }
};

// mutations
const mutations = {
  setFavoriteTotalCount(state, data) {
    state.favoriteTotalCount = data;
  },
  setCollectionTotalCount(state, data) {
    state.collectionTotalCount = data;
  },
  headChange(state) {
    //这里的state对应着上面这个state
    state.headChange = !state.headChange;
    //你还可以在这里执行其他的操作改变state
  },
  goPersonalCenter(state) {
    //这里的state对应着上面这个state
    state.goPersonalCenter = !state.goPersonalCenter;
    //你还可以在这里执行其他的操作改变state
  },
  registerChange(state) {
    //这里的state对应着上面这个state
    state.registerChange = !state.registerChange;
    //你还可以在这里执行其他的操作改变state
  },
  signChange(state) {
    //这里的state对应着上面这个state
    state.signChange = !state.signChange;
    //你还可以在这里执行其他的操作改变state
  },
  removeAct(state) {
    //这里的state对应着上面这个state
    state.removeAct = !state.removeAct;
    //你还可以在这里执行其他的操作改变state
  },
  setMember(state,member) {
    state.member = member;
  },
  removeMember(state) {
    state.member = null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/headChange.js